// extracted by mini-css-extract-plugin
export default {"flatpage__content":"style_flatpage__content__IBY2n"};